// 1. Select all elements you want to watch
const elementsToObserve = document.querySelectorAll('.observe-me');

// 2. Define what happens when the element is in view
const observerCallback = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // Add class when element enters the viewport
      entry.target.classList.add('in-view'); 
      
      // OPTIONAL: Stop observing if you only want the animation to happen once
      // observer.unobserve(entry.target); 
    } else {
      // OPTIONAL: Remove class when element leaves the viewport
      entry.target.classList.remove('in-view'); 
    }
  });
};

// 3. Configure options (threshold: 0.1 means 10% of the element must be visible)
const observerOptions = {
  root: null, // defaults to the browser viewport
  threshold: 0.1 
};

// 4. Create the observer instances and attach them to elements
const observer = new IntersectionObserver(observerCallback, observerOptions);

elementsToObserve.forEach(element => {
  observer.observe(element);
});
